<template>
	<div>
		<v-card dark>
			<v-card-text>
				<v-form ref="form" v-model="formValid" readonly>
					<v-row dense>
						<v-col cols="4" sm="2" md="2" lg="1">
							<c-input
								v-model="currentSystem.CODIGO"
								label="Código"
								placeholder="Código"
							/>
						</v-col>
						<v-spacer></v-spacer>
						<v-col cols="2">
							<div class="rounded text secondary">
								<span class="ml-2">Optante Simples</span>
								<v-radio-group v-model="currentSystem.EMPRESASIMPLES" dense row>
									<v-radio
										v-for="status in statusList"
										:key="status.value"
										:label="status.text"
										:value="status.value"
										dense
										class="customClass"
									></v-radio>
								</v-radio-group>
							</div>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input-documento
								v-model="currentSystem.CGC"
								:isBrasil="!isParaguai"
								:isDocumentoValido="isDocumentoValido"
							/>
						</v-col>
						<v-col cols="12" sm="9" md="4" lg="4">
							<c-input
								v-model="currentSystem.NOME"
								label="Nome Fantasia"
								placeholder="Digite o Nome Fantasia"
								:minLength="3"
								:maxLength="35"
							/>
						</v-col>
						<v-col cols="12" md="6" lg="6">
							<c-input
								v-model="currentSystem.RAZAOSOCIAL"
								label="Razão Social"
								placeholder="Digite a Razão Social"
								:minLength="3"
								:maxLength="80"
								:isRequired="true"
							/>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input
								v-model="currentSystem.IE"
								label="Inscrição Estadual"
								placeholder="Digite Inscrição Estadual"
								:maxLength="12"
								readonly
							/>
						</v-col>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input
								v-model="currentSystem.IM"
								label="Inscrição Municipal"
								placeholder="Digite Inscrição Municipal"
								:maxLength="12"
							/>
						</v-col>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input
								v-model="currentSystem.IESUBSTITUTO"
								label="IE Substituto Trib."
								placeholder="Digite IE Substituto Trib."
								:maxLength="12"
							/>
						</v-col>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input
								v-model="currentSystem.IJC"
								label="Inscrição Jta Comercial"
								placeholder="Digite Jta Comercial"
								:maxLength="12"
							/>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="2" sm="2" md="2" lg="1">
							<c-input-cep
								v-model="currentSystem.CEP"
								label="CEP"
								placeholder="Digite o CEP"
								:maxLength="8"
							>
							</c-input-cep>
						</v-col>
						<v-col sm="8" md="5" lg="5">
							<c-input
								v-model="currentSystem.ENDERECO"
								label="Endereço"
								placeholder="Digite o endereco"
								:maxLength="45"
							/>
						</v-col>
						<v-col cols="2" md="1" lg="1">
							<c-input
								v-model="currentSystem.NUMERO"
								label="Número"
								placeholder="Número"
								:maxLength="8"
							/>
						</v-col>
						<v-col cols="8" sm="4" md="2" lg="2">
							<c-input
								v-model="currentSystem.COMPLEMENTO"
								label="Complemento"
								placeholder="Complemento"
								:maxLength="25"
							/>
						</v-col>
						<v-col cols="6" sm="4" md="2" lg="2">
							<c-input
								v-model="currentSystem.BAIRRO"
								label="Bairro"
								placeholder="Digite o Bairro"
								:maxLength="45"
							></c-input>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="10" sm="5" md="5" lg="4">
							<v-combobox
								:items="cidadeList"
								v-model="currentSystem.CIDADE"
								item-text="DESCRICAO"
								item-value="CODIGO"
								label="Cidade"
								class="text-caption"
								placeholder="Cidade"
								outlined
								dense
							/>
						</v-col>
						<v-col cols="2" sm="1" md="1" lg="1">
							<c-input
								v-model="currentSystem.UF"
								label="UF"
								placeholder="Digite UF"
								:maxLength="2"
							/>
						</v-col>
						<v-col cols="6" sm="2" md="2" lg="2">
							<c-input
								v-model="currentSystem.FONE"
								label="Telefone"
								placeholder="Digite um Telefone"
								:maxLength="16"
							/>
						</v-col>
						<v-col cols="6" sm="2" md="2" lg="2">
							<c-input
								v-model="currentSystem.FAX"
								label="Telefone FAX"
								placeholder="Digite um Telefone FAX"
								:maxLength="16"
							/>
						</v-col>
						<v-col cols="6" sm="2" md="2" lg="2">
							<c-input
								v-model="currentSystem.WHATSAPP"
								label="WhatsApp"
								placeholder="Digite um Telefone WhatsApp"
								:maxLength="16"
							/>
						</v-col>
					</v-row>
					<v-divider class="mb-4" />
					<v-row dense>
						<v-col cols="12" sm="9" md="4" lg="4">
							<c-input
								v-model="currentSystem.NOMERESPONSAVEL"
								label="Nome Responsável"
								placeholder="Digite o Nome Responsável"
								:minLength="3"
								:maxLength="60"
								readonly
							/>
						</v-col>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input-documento
								v-model="currentSystem.CPFRESPONSAVEL"
								:isBrasil="!isParaguai"
								:isDocumentoValido="isDocumentoValidoResponsavel"
							/>
						</v-col>
					</v-row>
					<v-row dense>
						<v-col cols="12" sm="9" md="4" lg="4">
							<c-input
								v-model="currentSystem.NOMECONTADOR"
								label="Nome Contador"
								placeholder="Digite o Nome Contador"
								:minLength="3"
								:maxLength="60"
								readonly
							/>
						</v-col>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input-documento
								v-model="currentSystem.CPFCONTADOR"
								:isBrasil="!isParaguai"
								:isDocumentoValido="isDocumentoValidoContador"
							/>
						</v-col>
						<v-col cols="6" sm="3" md="2" lg="2">
							<c-input
								v-model="currentSystem.CRCCONTADOR"
								label="CRC Contador"
								placeholder="Digite o CRC Contador"
								:maxLength="14"
								readonly
							/>
						</v-col>
					</v-row>
					<v-divider class="mb-4" />
					<v-dialog
						v-model="dialogWebSettings"
						max-width="600px"
						transition="dialog-bottom-transition"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								color="primary"
								dark
								class="mb-2"
								v-bind="attrs"
								v-on="on"
								small
							>
								Configurações Web
							</v-btn>
						</template>
						<v-card dark>
							<v-card-title>
								<span class="headline">Configurações Web</span>
							</v-card-title>
							<v-card-text>
								<v-container>
									<v-form
										ref="formWebSettings"
										v-model="validWebSettings"
										readonly
									>
										<v-row dense>
											<v-col>
												<c-input
													v-model="currentSystem.HOMEPAGE"
													label="Home Page"
													placeholder="Digite a Home Page"
													:maxLength="50"
												/>
											</v-col>
										</v-row>
										<v-divider class="mb-5"></v-divider>
										<v-row dense>
											<v-col>
												<c-input
													v-model="currentSystem.EMAIL"
													label="E-mail"
													placeholder="Digite um email"
													:maxLength="50"
													:rules="formRules.emailFormat"
												/>
												<c-input
													v-model="currentSystem.EMAIL1"
													label="E-mail Alternativo"
													placeholder="Digite um email alternativo"
													:maxLength="50"
													:rules="formRules.emailFormat"
												/>
											</v-col>
											<v-col>
												<c-input
													v-model="currentSystem.SENHAEMAIL"
													label="Senha"
													placeholder="Senha do e-mail"
													:type="showPassword ? 'text' : 'password'"
													class="text-caption"
													:append-icon="
														showPassword ? 'mdi-eye' : 'mdi-eye-off'
													"
													@click:append="showPassword = !showPassword"
												/>
												<c-input
													v-model="currentSystem.SENHAEMAIL1"
													label="Senha e-mail Alternativo"
													placeholder="Senha do e-mail alternativo"
													:type="showPassword ? 'text' : 'password'"
													class="text-caption"
													:append-icon="
														showPassword ? 'mdi-eye' : 'mdi-eye-off'
													"
													@click:append="showPassword = !showPassword"
												/>
											</v-col>
										</v-row>
										<v-row dense>
											<v-col>
												<c-input
													v-model="currentSystem.SERVIDORDEEMAIL"
													label="Servidor e-mail saída"
													placeholder="Digite o servidor e-mail"
													:maxLength="50"
												/>
											</v-col>
											<v-col cols="2">
												<c-input
													v-model="currentSystem.PORTAEMAIL"
													label="Porta"
													placeholder="Ex: 587"
													:maxLength="50"
												/>
											</v-col>
										</v-row>
										<v-row>
											<v-col cols="5">
												<div class="rounded text secondary">
													<span class="ml-2">Requer Autenticação</span>
													<v-radio-group
														v-model="currentSystem.EMAILREQUERAUTENTICACAO"
														dense
														row
													>
														<v-radio
															v-for="status in statusList"
															:key="status.value"
															:label="status.text"
															:value="status.value"
															dense
															class="customClass"
														></v-radio>
													</v-radio-group>
												</div>
											</v-col>

											<v-spacer></v-spacer>
											<v-col cols="5">
												<div class="rounded text secondary">
													<span class="ml-2">Conexão Segura SSL</span>
													<v-radio-group
														v-model="currentSystem.EMAILSSL"
														dense
														row
													>
														<v-radio
															v-for="status in statusList"
															:key="status.value"
															:label="status.text"
															:value="status.value"
															dense
															class="customClass"
														></v-radio>
													</v-radio-group>
												</div>
											</v-col>
										</v-row>
									</v-form>
								</v-container>
							</v-card-text>
							<form-buttons
								@goBack="dialogWebSettings = false"
								@submitForm="dialogWebSettings = false"
								:disabledSave="true"
							/>
						</v-card>
					</v-dialog>
				</v-form>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import {
	validaCpfCnpj,
	validaRUC,
	consultaViaCep,
	emailFormat,
} from '@/utils/utils'

import cInputDocumento from '@/components/shared/base-input/BaseInputCpfCnpj'
import cInput from '@/components/shared/base-input/BaseInput'
import cInputCep from '@/components/shared/base-input/BaseInputCEP'
import FormButtons from '@/components/shared/base-buttons/FormButtons'

import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'FormDadosPrincipais',
	components: {
		cInput,
		cInputDocumento,
		cInputCep,
		FormButtons,
	},
	data: () => ({
		dialogWebSettings: false,
		validWebSettings: true,
		showPassword: false,
		formValid: false,
		cidadeList: [],
		statusList: [
			{ text: 'Sim', value: 'S' },
			{ text: 'Não', value: 'N' },
		],
		form: {},
	}),
	computed: {
		...mapGetters({
			cityList: 'cityModule/getComboBoxList',
			currentSystem: 'systemModule/getCurrentSystem',
		}),

		isParaguai() {
			return false
		},

		isDocumentoValido() {
			// se digitar o cpf ou cnpj ira validar, caso contrario sempre será verdadeiro para salvar
			let documento = this.form.CGC
			if (documento) {
				if (this.isParaguai) {
					return validaRUC(documento)
				} else {
					return validaCpfCnpj(documento)
				}
			} else return false
		},
		isDocumentoValidoResponsavel() {
			// se digitar o cpf ou cnpj ira validar, caso contrario sempre será verdadeiro para salvar
			let documento = this.form.CPFRESPONSAVEL
			if (documento) {
				if (this.isParaguai) {
					return validaRUC(documento)
				} else {
					return validaCpfCnpj(documento)
				}
			} else return false
		},
		isDocumentoValidoContador() {
			// se digitar o cpf ou cnpj ira validar, caso contrario sempre será verdadeiro para salvar
			let documento = this.form.CPFCONTADOR
			if (documento) {
				if (this.isParaguai) {
					return validaRUC(documento)
				} else {
					return validaCpfCnpj(documento)
				}
			} else return false
		},

		formRules() {
			const rules = {
				emailFormat: [emailFormat(true)],
				requiredField: [(value) => !!value || 'Campo Obrigatório.'],
			}

			return rules
		},
	},

	methods: {
		...mapActions('cityModule', ['getCities']),
		...mapActions('dialogModule', [
			'setShowLoadingDialog',
			'setLoadingDialogMessage',
		]),

		async consultaCep($event) {
			try {
				let param = $event.target.value ?? null
				if (!param || param.replace(/[^0-9]+/g, '').length <= 7) return

				const response = await consultaViaCep(param)

				// quando o cep nao existe, retorna erro: true
				if (response && response.erro) return

				this.form.ENDERECO = response.logradouro.toUpperCase()
				this.form.COMPLEMENTO = response.complemento.toUpperCase()
				this.form.BAIRRO = response.bairro.toUpperCase()
				this.form.UF = response.uf
				this.form.CODIGOMUNICIPIO = response.ibge
				// fim
			} catch (error) {
				this.$toasted.error(error, { duration: null })
			}
		},

		updateUF(value) {
			if (value && value.UF.length > 0) {
				this.form.UF = value.UF
			}
		},

		search($event, property) {
			try {
				clearTimeout(this.timer)
				let param = $event.target.value ?? null

				if (!param || param.trim().length <= 0) return

				param = param
					.trim()
					.split('-')[0]
					.trim()

				this.timer = setTimeout(() => {
					let payload = { page: 1, hibrido: param }

					let fnc = this.getCities
					let list = 'cityList'

					if (!this.form[property] || this.form[property].CODIGO !== param) {
						this.getDados(payload, property, fnc, list)
					}
				}, 600)
			} catch (error) {
				this.$toasted.error(`Erro na função search() ${error}`)
			}
		},

		async getDados(payload, property, fnc, ownerList) {
			try {
				await fnc(payload)
				this[`${property}List`] = this[ownerList]
			} catch (error) {
				this.$toasted.error(error, { duration: null })
			}
		},

		// async setData() {},

		async fetch() {
			try {
				// await this.setData()
			} catch (error) {
				this.$toasted.error(error, { duration: null })
			}
		},
	},
	created() {
		this.fetch()
	},
}
</script>

<style scoped>
.customClass >>> label {
	font-size: 0.8em;
}
</style>
